export const COPY_EVENT_STARTED = "@writeme/copy-events.started";
export const COPY_EVENT_DISPATCHED = "@writeme/copy-events.dispatched";
export const COPY_EVENT_FINISHED = "@writeme/copy-events.finished";
